// Copyright 1999-2018. Plesk International GmbH. All rights reserved.

import { createElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import Spinner from '../Spinner';
import { CLS_PREFIX } from '../../constants';

import '../../helpers/base.less';
import './ContentLoader.less';

/**
 * `ContentLoader` component indicates that the system is performing a certain operation and alerts users that they need
 * to wait for the operation to complete. `ContentLoader` is an indeterminate indicator: in other words, it does not tell
 * the user how long it will take for the operation to complete, so it should be used when the operation takes a relatively
 * short amount of time (from 2 to 10 seconds). If the operation takes longer than 10 seconds to complete on average,
 * use a progress bar instead.
 */
const ContentLoader = ({
    baseClassName,
    className,
    text,
    overlay,
    children,
    backdrop,
    blur,
    loading,
    ...props
}) => {
    if (!loading) {
        return children;
    }

    if (children && overlay) {
        children = <div className={classNames(`${baseClassName}__content`, blur && `${baseClassName}__content--blur`)}>{children}</div>;
    }

    return (
        <div className={classNames(baseClassName, !children && overlay && `${baseClassName}--overlay`, className)} {...props}>
            {children}
            <div className={classNames(`${baseClassName}__container`, overlay && `${baseClassName}__overlay`, backdrop && `${baseClassName}__backdrop`)}>
                <div className={`${baseClassName}__loader`}>
                    <Spinner className={`${baseClassName}__indicator`} />
                    {text && <div className={`${baseClassName}__text`}>{text}</div>}
                </div>
            </div>
        </div>
    );
};

ContentLoader.propTypes = {
    /**
     * Allows to set the text near the indicator.
     */
    text: PropTypes.node,
    /**
     * @ignore
     */
    overlay: PropTypes.bool,
    /**
     * @ignore
     */
    backdrop: PropTypes.bool,
    /**
     * @ignore
     */
    blur: PropTypes.bool,
    /**
     * @ignore
     */
    loading: PropTypes.bool,
    /**
     * @ignore
     */
    children: PropTypes.node,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};

ContentLoader.defaultProps = {
    text: null,
    overlay: false,
    backdrop: false,
    blur: false,
    loading: true,
    children: null,
    className: null,
    baseClassName: `${CLS_PREFIX}content-loader`,
};

export default ContentLoader;



// WEBPACK FOOTER //
// ./components/ContentLoader/ContentLoader.js